import Lenis from 'lenis'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

(function () {
    'use strict';

    // Initialisation de Lenis
    const lenis = new Lenis({
        lerp: 0.1, // Fluidité (0.1 = standard)
        smoothWheel: true,
        smoothTouch: false, // On désactive souvent sur mobile pour garder le natif
    });

    // Intégration avec GSAP ScrollTrigger
    // Lenis fait défiler, donc on dit à ScrollTrigger de mettre à jour ses calculs quand Lenis scroll
    lenis.on('scroll', ScrollTrigger.update);

    // On ajoute le ticker de Lenis à celui de GSAP pour qu'ils soient synchros
    gsap.ticker.add((time) => {
        lenis.raf(time * 1000);
    });

    // On désactive le lissage de l'interpolation GSAP pour éviter les conflits de rafraîchissement
    gsap.ticker.lagSmoothing(0);

    console.log('Lenis Smooth Scroll initialized');

    // Export pour usage externe éventuel
    window.lenis = lenis;
})();
